"use client";

import { useEffect } from "react";
import { toast } from "sonner";
import { SubmitButton } from "@/components/ui/submit-button";
import { useSecurity } from "@/hooks/use-security";

interface FormState {
  message: string;
  success: boolean;
}

type FormProps<T extends FormState> = {
  action: (payload: FormData) => void;
  state: T;
  children: React.ReactNode;
  className?: string;
  submitButton: {
    children: React.ReactNode;
    pendingText?: string;
    variant?: "default" | "yellow";
    className?: string;
  };
};

export function Form<T extends FormState>({
  action,
  state,
  children,
  className = "",
  submitButton,
}: FormProps<T>) {
  const { csrfToken, timestampHash, isLoading } = useSecurity();

  useEffect(() => {
    if (state.message) {
      if (state.success) {
        toast.success(state.message);
      } else {
        toast.error(state.message);
      }
    }
  }, [state.message, state.success]);

  return (
    <form action={action} className={className}>
      <input type="hidden" name="csrf-token" value={csrfToken} />
      <input type="hidden" name="timestamp-hash" value={timestampHash} />

      <div
        style={{
          position: "absolute",
          left: "-9999px",
          opacity: 0,
          pointerEvents: "none",
        }}
      >
        <label htmlFor="website">Website (leave blank):</label>
        <input
          type="text"
          id="website"
          name="website"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
        />
      </div>

      {children}

      <SubmitButton
        variant={submitButton.variant}
        pendingText={submitButton.pendingText}
        className={submitButton.className}
        disabled={isLoading}
      >
        {submitButton.children}
      </SubmitButton>
    </form>
  );
}
